import { UseFormReturn } from 'react-hook-form'

import { PollFormClosesAt } from './PollFormClosesAt.js'
import { PollFormOpensAt } from './PollFormOpensAt.js'
import { PollFormSelectionType } from './PollFormSelectionType.js'
import { PollFormValues } from './types.js'

export function PollFormSettings({
  form,
}: {
  form: UseFormReturn<PollFormValues>
}) {
  return (
    <div className="space-y-4 py-6 ">
      <PollFormSelectionType form={form} />
      <PollFormOpensAt form={form} />
      <PollFormClosesAt form={form} />
    </div>
  )
}
